import { http } from '../axios';
import { shopPrefix } from '../../config';
import { mapProductTypeToRequestKey, ProductType } from '../../../models/ProductType';
import { ProductFilter } from '../../../models/Product';
import { ProductsResponseOut } from '../../store/api';

const url = `${shopPrefix}/v2/standard/allproducts/:loanFormat/:productType/products`;

type QueryParams = {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    ageCategory?: string;
    shopLanguage?: string;
};

export const fetchAllProductsByProductTypeProducts = (
    loanFormat: string,
    productType: ProductType,
    params: QueryParams,
    body: ProductFilter
) => {
    return http
        .post<ProductsResponseOut>(url, body, {
            pathParams: { loanFormat, productType: mapProductTypeToRequestKey(productType) },
            params
        })
        .then(res => res.data);
};
